import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('sheet_rates_reviews')
const reducer = generator.generate()

export default reducer
